export const env = {
  // Use relative URL to leverage Next.js rewrites proxy (eliminates CORS preflight)
  NEXT_PUBLIC_API_URL:
    process.env.NEXT_PUBLIC_API_URL ?? '/api',
}
